<template>
  <main class="touch-disabled">
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero">
        <template #footer-title>
          <div class="grid md:grid-cols-12 md:pb-2 -md:hidden">
            <div class="md:col-span-10 md:col-start-3 print:mt-0 print:relative print:top-[8px] print:left-[-13px]">
              <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] print:inline-block">
                <AtomButtonDropdown
                  class="-md:w-full print:!w-auto print:!inline-block"
                  :items="clubItems"
                  :initial-index="initialClub"
                  @select="onClubSelect"
                />
                <AtomButtonDropdown
                  class="-md:w-full print:!w-auto print:!inline-block"
                  :items="clubAgeItems"
                  :initial-index="initialAge"
                  @select="onAgeSelect"
                />
              </div>
            </div>
          </div>
        </template>
      </OrganismHero>
      <template #footer>
        <client-only>
          <div class="print:mt-0 print:relative print:top-[8px] print:left-[-13px]">
            <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] print:inline-block md:hidden">
              <AtomButtonDropdown
                class="-md:w-full print:!w-auto print:!inline-block"
                :items="clubItems"
                :initial-index="initialClub"
                @select="onClubSelect"
              />
              <AtomButtonDropdown
                class="-md:w-full print:!w-auto print:!inline-block"
                :items="clubAgeItems"
                :initial-index="initialAge"
                @select="onAgeSelect"
              />
            </div>
            <div class="flex justify-between mt-3">
              <div />
              <div class="print:!hidden -md:w-full">
                <AtomButton
                  tag="button"
                  class="btn btn-sm btn-outline btn-filter w-full mr-2 !flex !justify-between md:!hidden"
                  @click="openModalFilters"
                >
                  <span class="text-base">Фильтры</span>
                  <span v-if="filtersCount" class="flex items-center">
                    <span
                      class="text-[11px] text-white bg-gray-100 rounded-full inline-flex items-center justify-center w-5 h-5 mr-2"
                      >{{ filtersCount }}</span
                    >
                    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.9996 2.92503H10.0996"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3.59901 2.92503H0.999023"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.19784 5.20001C7.45429 5.20001 8.47284 4.18146 8.47284 2.92502C8.47284 1.66857 7.45429 0.650024 6.19784 0.650024C4.9414 0.650024 3.92285 1.66857 3.92285 2.92502C3.92285 4.18146 4.9414 5.20001 6.19784 5.20001Z"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.9984 10.075H11.3984"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.89901 10.075H0.999023"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.79843 12.35C10.0549 12.35 11.0734 11.3314 11.0734 10.075C11.0734 8.81855 10.0549 7.8 8.79843 7.8C7.54199 7.8 6.52344 8.81855 6.52344 10.075C6.52344 11.3314 7.54199 12.35 8.79843 12.35Z"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </AtomButton>
                <AtomButton tag="button" class="btn btn-sm btn-outline btn-print mr-2 -md:!hidden" @click="onPrint">
                  <span class="">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.04297 6.33317H13.9596V4.6665C13.9596 2.99984 13.3346 2.1665 11.4596 2.1665H8.54297C6.66797 2.1665 6.04297 2.99984 6.04297 4.6665V6.33317Z"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.3346 13V16.3333C13.3346 18 12.5013 18.8333 10.8346 18.8333H9.16797C7.5013 18.8333 6.66797 18 6.66797 16.3333V13H13.3346Z"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.5 8.83331V13C17.5 14.6666 16.6667 15.5 15 15.5H13.3333V13H6.66667V15.5H5C3.33333 15.5 2.5 14.6666 2.5 13V8.83331C2.5 7.16665 3.33333 6.33331 5 6.33331H15C16.6667 6.33331 17.5 7.16665 17.5 8.83331Z"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.1654 13H13.157H5.83203"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.83203 9.6665H8.33203"
                        stroke="#282929"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </AtomButton>
              </div>
            </div>
            <div class="flex justify-between mt-2 print:!hidden -md:hidden">
              <div class="flex justify-between">
                <div class="-md:w-full">
                  <AtomButtonDropdown
                    v-if="$device.isDesktop"
                    class="ml-2"
                    theme-light
                    :invert-theme-selected="true"
                    small
                    :custom-label="$route.query[FILTER_KEYS.CATEGORIES] ? 'Направление 1' : 'Направления'"
                    :items="items[FILTER_KEYS.CATEGORIES]"
                    :initial-index="initial[FILTER_KEYS.CATEGORIES]"
                    :clearable="true"
                    :dropdown-auto-width="true"
                    :dropdown-min-width="true"
                    @select="onFilterSelect(FILTER_KEYS.CATEGORIES, $event)"
                  />
                </div>
                <div class="-md:w-full">
                  <AtomButtonDropdown
                    v-if="$device.isDesktop"
                    class="ml-2"
                    theme-light
                    :invert-theme-selected="true"
                    small
                    :custom-label="$route.query[FILTER_KEYS.ZONE] ? 'Зона 1' : 'Зоны'"
                    :items="items[FILTER_KEYS.ZONE]"
                    :initial-index="initial[FILTER_KEYS.ZONE]"
                    :clearable="true"
                    :dropdown-auto-width="true"
                    @select="onFilterSelect(FILTER_KEYS.ZONE, $event)"
                  />
                </div>
                <div class="-md:w-full">
                  <AtomButtonDropdown
                    v-if="$device.isDesktop"
                    class="ml-2"
                    theme-light
                    :invert-theme-selected="true"
                    small
                    :custom-label="$route.query[FILTER_KEYS.TRAINING] ? 'Тренировка 1' : 'Тренировки'"
                    :items="items[FILTER_KEYS.TRAINING]"
                    :initial-index="initial[FILTER_KEYS.TRAINING]"
                    :clearable="true"
                    :dropdown-auto-width="true"
                    @select="onFilterSelect(FILTER_KEYS.TRAINING, $event)"
                  />
                </div>
                <div class="-md:w-full">
                  <AtomButtonDropdown
                    v-if="$device.isDesktop"
                    class="ml-2"
                    theme-light
                    :invert-theme-selected="true"
                    small
                    :custom-label="$route.query[FILTER_KEYS.TRAINER] ? 'Тренер 1' : 'Тренеры'"
                    :items="items[FILTER_KEYS.TRAINER]"
                    :initial-index="initial[FILTER_KEYS.TRAINER]"
                    :clearable="true"
                    :dropdown-auto-width="true"
                    @select="onFilterSelect(FILTER_KEYS.TRAINER, $event)"
                  />
                </div>
              </div>
              <div>
                <MoleculeSwitch
                  v-for="item in switchesFiltered"
                  :id="item.id"
                  :key="item.key"
                  class="mr-2"
                  :label="item.label"
                  :icon="item.icon"
                  :selected="!!$route.query[item.id]"
                  @select="onSwitchSelect"
                />
              </div>
            </div>
          </div>
        </client-only>
      </template>
    </SectionHero>
    <Modal v-if="modalFilters" title="Фильтры" :icon="true" :small="true" @close="modalFilters = null">
      <template #controls>
        <AtomButton v-if="filtersCount" class="btn-sm btn-fill mb-[-4px]" tag="button" @click="filtersClear">
          <span>Очистить ({{ filtersCount }})</span>
        </AtomButton>
      </template>
      <div>
        <div class="flex flex-col">
          <span class="btn-item" @click="openModalSelects(FILTER_KEYS.CATEGORIES)">
            <span>
              Направления
              <span
                v-if="$route.query[FILTER_KEYS.CATEGORIES]"
                class="text-[11px] text-white bg-gray-100 rounded-full inline-flex items-center justify-center min-w-[20px] p-1 h-5 ml-1"
                >1</span
              >
            </span>
            <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L8 6.5L1 12.5" stroke="#282929" stroke-linecap="round" />
            </svg>
          </span>
          <span class="btn-item" @click="openModalSelects(FILTER_KEYS.ZONE)">
            <span>
              Зоны
              <span
                v-if="$route.query[FILTER_KEYS.ZONE]"
                class="text-[11px] text-white bg-gray-100 rounded-full inline-flex items-center justify-center min-w-[20px] p-1 h-5 ml-1"
                >1</span
              >
            </span>
            <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L8 6.5L1 12.5" stroke="#282929" stroke-linecap="round" />
            </svg>
          </span>
          <span class="btn-item" @click="openModalSelects(FILTER_KEYS.TRAINING)">
            <span
              >Тренировки
              <span
                v-if="$route.query[FILTER_KEYS.TRAINING]"
                class="text-[11px] text-white bg-gray-100 rounded-full inline-flex items-center justify-center min-w-[20px] p-1 h-5 ml-1"
                >1</span
              ></span
            >
            <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L8 6.5L1 12.5" stroke="#282929" stroke-linecap="round" />
            </svg>
          </span>
          <span class="btn-item" @click="openModalSelects(FILTER_KEYS.TRAINER)">
            <span>
              Тренеры
              <span
                v-if="$route.query[FILTER_KEYS.TRAINER]"
                class="text-[11px] text-white bg-gray-100 rounded-full inline-flex items-center justify-center min-w-[20px] p-1 h-5 ml-1"
                >1</span
              >
            </span>
            <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L8 6.5L1 12.5" stroke="#282929" stroke-linecap="round" />
            </svg>
          </span>
        </div>
        <div class="mt-3">
          <MoleculeRadio
            v-for="item in switchesFiltered"
            :id="item.id"
            :key="item.key"
            class="mr-2"
            type="checkbox"
            :label="item.label"
            :icon="item.icon"
            :value="true"
            :checked="Boolean($route.query[item.id])"
            @input="onSwitchSelect({ id: item.id, value: $event != $route.query[item.id] })"
          />
        </div>
      </div>
    </Modal>
    <Modal v-if="MODAL_SELECT_KEY" :title="modalSelectTitle" :small="true" :nested="true" @close="closeModalSelects">
      <div>
        <OrganismRadioList
          :list="modalSelectItems"
          :value="$route.query[MODAL_SELECT_KEY]"
          :name="MODAL_SELECT_KEY"
          @input="onSelectChange"
        />
      </div>
    </Modal>
    <SectionDefault>
      <NuxtChild :context="{ cityId: cityId, blocks: blocks }" />
    </SectionDefault>
  </main>
</template>

<script>
import { mapActions } from 'vuex'

import AtomButton from '~/components/atoms/AtomButton'
import AtomButtonDropdown from '~/components/atoms/AtomButtonDropdown'
import pageBuilder from '~/components/mixins/pageBuilder.js'
import MoleculeRadio from '~/components/molecules/forms/MoleculeRadio'
import MoleculeSwitch from '~/components/molecules/forms/MoleculeSwitch'
import OrganismHero from '~/components/organisms/layouts/OrganismHero'
import OrganismRadioList from '~/components/organisms/layouts/OrganismRadioList'
import Modal from '~/components/templates/layouts/Modal'
import SectionDefault from '~/components/templates/layouts/SectionDefault'
import SectionHero from '~/components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'timetable',
})

const FILTER_KEYS = {
  CATEGORIES: 'categories',
  ZONE: 'zone',
  TRAINING: 'training',
  TRAINER: 'trainer',
}

export default {
  name: 'Timetable',
  components: {
    SectionDefault,
    SectionHero,
    OrganismHero,
    OrganismRadioList,
    AtomButton,
    AtomButtonDropdown,
    MoleculeSwitch,
    MoleculeRadio,
    Modal,
  },
  mixins: [mixinPageBuilder],
  data: ctx => {
    return {
      cityId: null,
      modalFilters: false,
      MODAL_SELECT_KEY: null,
      hero: {
        title1: 'Расписание',
        title2: 'тренировок',
        breadcrumbs: ctx.$breadcrumbs.timetable(),
      },
      ageItems: [
        { slug: 'adult', text: 'Для взрослых' },
        { slug: 'kids', text: 'Для детей' },
      ],
      adultAgeItems: [{ slug: 'adult', text: 'Для взрослых' }],
      FILTER_KEYS,
      switches: [
        {
          id: 'minigroup',
          label: 'Мини-группы',
        },
        {
          id: 'sections',
          label: 'Секции',
        },
        {
          id: 'paid',
          label: 'Платные групповые',
          icon: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.63242 5.0874C6.26088 5.0874 5.91992 5.41074 5.91992 5.85615C5.91992 6.16585 5.98655 6.30195 6.04077 6.37112C6.0995 6.44604 6.20072 6.51611 6.41055 6.59063L8.93071 7.46612C9.21368 7.56641 9.52463 7.71809 9.75483 8.01175C9.98967 8.31132 10.0887 8.69085 10.0887 9.14365C10.0887 10.0982 9.34213 10.9124 8.37617 10.9124H6.80742C5.73989 10.9124 4.91992 10.0153 4.91992 8.95615C4.91992 8.68001 5.14378 8.45615 5.41992 8.45615C5.69606 8.45615 5.91992 8.68001 5.91992 8.95615C5.91992 9.50946 6.33745 9.9124 6.80742 9.9124H8.37617C8.74771 9.9124 9.08867 9.58906 9.08867 9.14365C9.08867 8.83395 9.02205 8.69786 8.96782 8.62868C8.90909 8.55376 8.80787 8.4837 8.59804 8.40917L6.07788 7.53369C5.79492 7.43339 5.48396 7.28172 5.25376 6.98806C5.01892 6.68848 4.91992 6.30895 4.91992 5.85615C4.91992 4.90156 5.66646 4.0874 6.63242 4.0874H8.20117C9.2687 4.0874 10.0887 4.98446 10.0887 6.04365C10.0887 6.31979 9.86481 6.54365 9.58867 6.54365C9.31253 6.54365 9.08867 6.31979 9.08867 6.04365C9.08867 5.49035 8.67114 5.0874 8.20117 5.0874H6.63242Z" fill="#CFD1D6"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 3.25C7.77614 3.25 8 3.47386 8 3.75V11.25C8 11.5261 7.77614 11.75 7.5 11.75C7.22386 11.75 7 11.5261 7 11.25V3.75C7 3.47386 7.22386 3.25 7.5 3.25Z" fill="#CFD1D6"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1.75C4.32436 1.75 1.75 4.32436 1.75 7.5C1.75 10.6756 4.32436 13.25 7.5 13.25C10.6756 13.25 13.25 10.6756 13.25 7.5C13.25 4.32436 10.6756 1.75 7.5 1.75ZM0.75 7.5C0.75 3.77208 3.77208 0.75 7.5 0.75C11.2279 0.75 14.25 3.77208 14.25 7.5C14.25 11.2279 11.2279 14.25 7.5 14.25C3.77208 14.25 0.75 11.2279 0.75 7.5Z" fill="#CFD1D6"/>
        </svg>`,
        },
      ],
    }
  },
  head: {
    meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }],
  },
  meta: {
    theme: 'dark',
  },
  computed: {
    items() {
      return {
        [this.FILTER_KEYS.CATEGORIES]: this.$store.getters['modules/classes/categoriesItems'],
        [this.FILTER_KEYS.ZONE]: this.$store.getters['modules/classes/zonesItems'],
        [this.FILTER_KEYS.TRAINING]: this.$store.getters['modules/classes/trainingItems'],
        [this.FILTER_KEYS.TRAINER]: this.$store.getters['modules/classes/trainersItems'],
      }
    },
    initial() {
      const findIndex = FILTER_KEY => {
        return (this.items[FILTER_KEY] || []).findIndex(({ slug }) => slug == this.$route.query[FILTER_KEY])
      }

      return {
        [this.FILTER_KEYS.CATEGORIES]: findIndex(this.FILTER_KEYS.CATEGORIES),
        [this.FILTER_KEYS.ZONE]: findIndex(this.FILTER_KEYS.ZONE),
        [this.FILTER_KEYS.TRAINING]: findIndex(this.FILTER_KEYS.TRAINING),
        [this.FILTER_KEYS.TRAINER]: findIndex(this.FILTER_KEYS.TRAINER),
      }
    },
    clubs() {
      return this.$store.getters['modules/content/clubs']
    },
    cityItems() {
      return this.$store.getters['modules/content/getClubsTownsAsDropdown']
    },
    clubItems() {
      return this.clubs.map(club => ({ text: club.title, slug: club.slug }))
    },
    initialCity() {
      const club = this.clubs.find(club => club.slug == this.$route.params.club)
      if (club) {
        return this.cityItems.findIndex(({ cityId }) => cityId == club.city.id)
      }
      return 0
    },
    initialClub() {
      const initial = this.clubItems.findIndex(({ slug }) => slug == this.$route.params.club)
      return initial === -1 ? 0 : initial
    },
    initialAge() {
      const initial = this.ageItems.findIndex(({ slug }) => slug === this.$route.params.age)
      return initial === -1 ? 0 : initial
    },
    clubAgeItems() {
      const club = this.clubs.find(club => club.slug === this.$route.params.club)
      return club && club.kidsClub ? this.ageItems : this.adultAgeItems
    },
    modalSelectTitle() {
      return {
        [this.FILTER_KEYS.ZONE]: 'Зоны',
        [this.FILTER_KEYS.TRAINING]: 'Тренировки',
        [this.FILTER_KEYS.TRAINER]: 'Тренеры',
      }[this.MODAL_SELECT_KEY]
    },
    modalSelectItems() {
      return (this.items[this.MODAL_SELECT_KEY] || []).map(item => ({
        value: item.slug,
        label: item.text,
      }))
    },
    filtersCount() {
      return [
        this.$route.query[this.FILTER_KEYS.ZONE],
        this.$route.query[this.FILTER_KEYS.TRAINING],
        this.$route.query[this.FILTER_KEYS.TRAINER],
        ...this.switches.map(({ id }) => this.$route.query[id]),
      ].filter(Boolean).length
    },
    timetables() {
      return this.$store.getters['modules/classes/timetables']
    },
    switchesFiltered: function () {
      const timetables = this.timetables
      const keys = Object.keys(timetables).map(key => +key)
      const swithes = new Map()

      keys.forEach(
        function (key) {
          const timeKeys = Object.keys(this.obj[key])

          timeKeys.forEach(
            function (timeKey) {
              const timeArr = this.obj[key][timeKey]

              timeArr.forEach(
                function (item) {
                  item?.minigroup &&
                    !item?.old &&
                    !this.res.has('minigroup') &&
                    this.res.set('minigroup', {
                      id: 'minigroup',
                      label: 'Мини-группы',
                    })

                  item?.section &&
                    !item?.old &&
                    !this.res.has('sections') &&
                    this.res.set('sections', {
                      id: 'sections',
                      label: 'Секции',
                    })

                  item?.specialgroup &&
                    !item?.old &&
                    !this.res.has('paid') &&
                    this.res.set('paid', {
                      id: 'paid',
                      label: 'Платные групповые',
                      icon: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.63242 5.0874C6.26088 5.0874 5.91992 5.41074 5.91992 5.85615C5.91992 6.16585 5.98655 6.30195 6.04077 6.37112C6.0995 6.44604 6.20072 6.51611 6.41055 6.59063L8.93071 7.46612C9.21368 7.56641 9.52463 7.71809 9.75483 8.01175C9.98967 8.31132 10.0887 8.69085 10.0887 9.14365C10.0887 10.0982 9.34213 10.9124 8.37617 10.9124H6.80742C5.73989 10.9124 4.91992 10.0153 4.91992 8.95615C4.91992 8.68001 5.14378 8.45615 5.41992 8.45615C5.69606 8.45615 5.91992 8.68001 5.91992 8.95615C5.91992 9.50946 6.33745 9.9124 6.80742 9.9124H8.37617C8.74771 9.9124 9.08867 9.58906 9.08867 9.14365C9.08867 8.83395 9.02205 8.69786 8.96782 8.62868C8.90909 8.55376 8.80787 8.4837 8.59804 8.40917L6.07788 7.53369C5.79492 7.43339 5.48396 7.28172 5.25376 6.98806C5.01892 6.68848 4.91992 6.30895 4.91992 5.85615C4.91992 4.90156 5.66646 4.0874 6.63242 4.0874H8.20117C9.2687 4.0874 10.0887 4.98446 10.0887 6.04365C10.0887 6.31979 9.86481 6.54365 9.58867 6.54365C9.31253 6.54365 9.08867 6.31979 9.08867 6.04365C9.08867 5.49035 8.67114 5.0874 8.20117 5.0874H6.63242Z" fill="#CFD1D6"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 3.25C7.77614 3.25 8 3.47386 8 3.75V11.25C8 11.5261 7.77614 11.75 7.5 11.75C7.22386 11.75 7 11.5261 7 11.25V3.75C7 3.47386 7.22386 3.25 7.5 3.25Z" fill="#CFD1D6"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1.75C4.32436 1.75 1.75 4.32436 1.75 7.5C1.75 10.6756 4.32436 13.25 7.5 13.25C10.6756 13.25 13.25 10.6756 13.25 7.5C13.25 4.32436 10.6756 1.75 7.5 1.75ZM0.75 7.5C0.75 3.77208 3.77208 0.75 7.5 0.75C11.2279 0.75 14.25 3.77208 14.25 7.5C14.25 11.2279 11.2279 14.25 7.5 14.25C3.77208 14.25 0.75 11.2279 0.75 7.5Z" fill="#CFD1D6"/>
                      </svg>`,
                    })
                },
                {
                  res: this.res,
                },
              )
            },
            {
              obj: this.obj,
              res: this.res,
            },
          )
        },
        {
          obj: timetables,
          res: swithes,
        },
      )

      return [...swithes.values()]
    },
  },
  watch: {
    '$route.query'() {
      this.setViewFilters(this.$route.query)
    },
    items(next, prev) {
      // dropdown emits update on items change
      if (this.$device.isDesktop) return

      const update = FILTER_KEY => {
        if (next[FILTER_KEY] === prev[FILTER_KEY]) return
        const index = this.initial[FILTER_KEY]
        const slug = this.items[FILTER_KEY][index]?.slug
        this.updateRouteQuery(slug, FILTER_KEY)
      }
      update(this.FILTER_KEYS.TRAINING)
      update(this.FILTER_KEYS.TRAINER)
    },
  },
  created() {
    this.cityId = (this.cityItems[this.initialCity] || {}).cityId
    this.setViewFilters(this.$route.query)
  },
  beforeMount() {
    if (!this.$route.params.club) {
      const club = this.$store.getters['modules/content/geopositionClub']
      this.$router.replace(`/timetable/${club.slug}/adult`)
    }
  },
  methods: {
    ...mapActions({
      setViewFilters: 'modules/classes/setViewFilters',
    }),
    onSelectChange(value) {
      const slug = value == this.$route.query[this.MODAL_SELECT_KEY] ? undefined : value
      this.updateRouteQuery(slug, this.MODAL_SELECT_KEY)
    },
    onClubSelect(i) {
      const item = this.clubItems[i] || {}
      const club = this.clubs.find(club => club.slug === item.slug)
      if (this.$route.params.club === club.slug) return
      if (!this.$route.params.club && i === 0) return

      this.$router.push(`/timetable/${club.slug}/adult`)

      this.cityId = club.city.id
    },
    onAgeSelect(i) {
      const age = this.ageItems[i]
      if (age) {
        this.$router.push(`/timetable/${this.$route.params.club}/${age.slug}`)
      }
    },
    onFilterSelect(FILTER_KEY, i) {
      const items = this.items[FILTER_KEY] || []
      this.updateRouteQuery(items[i]?.slug, FILTER_KEY)
    },
    updateRouteQuery(slug, key) {
      if (slug !== this.$route.query[key]) {
        this.$router
          .replace({
            query: {
              ...this.$route.query,
              [key]: slug,
            },
          })
          .catch(() => {})
      }
    },
    filtersClear() {
      const {
        [this.FILTER_KEYS.ZONE]: _,
        [this.FILTER_KEYS.TRAINING]: __,
        [this.FILTER_KEYS.TRAINER]: ___,
        ...query
      } = this.$route.query
      this.switches.forEach(({ id }) => {
        delete query[id]
      })
      this.$router.replace({ query })
    },
    onSwitchSelect({ id, value }) {
      this.updateRouteQuery(value || undefined, id)
    },
    onPrint() {
      window.print()
    },
    openModalFilters() {
      this.modalFilters = !this.modalFilters
    },
    closeModalSelects() {
      this.MODAL_SELECT_KEY = null
    },
    openModalSelects(FILTER_KEY) {
      this.MODAL_SELECT_KEY = FILTER_KEY
    },
  },
}
</script>

<style lang="postcss" scoped>
.touch-disabled {
  touch-action: pan-y, pan-x;
}
.btn-item {
  @apply text-base py-3 border-b border-gray-500 flex justify-between items-center;
}
.btn-filter {
  @apply !border-gray-100;
  &:before {
    @apply !hidden;
  }
}
.btn-print {
  @apply !border-gray-100 !px-3;
  &:hover {
    svg path {
      @apply stroke-white;
    }
  }
}
</style>
